import { supabase } from './supabase';

// Public forms are submitted through the `submit-public` Edge Function (Turnstile + rate limiting), never
// by calling the database functions directly.

export const newIdempotencyKey = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const b = window.crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
};

export class SubmitError extends Error {}

const GENERIC = 'Something went wrong. Please try again or contact the school directly.';

// Resolves to the response body ({ reference_number } for an application, { ok: true } for a message);
// rejects with a SubmitError whose message is safe to show to a visitor.
export async function submitPublic({ kind, payload, idempotencyKey, turnstileToken }) {
  const { data, error } = await supabase.functions.invoke('submit-public', {
    body: { kind, payload, idempotency_key: idempotencyKey, turnstile_token: turnstileToken }
  });
  if (!error) return data;

  let message = GENERIC;
  try {
    // FunctionsHttpError carries the Response; the function returns { error } with a visitor-safe message.
    const body = await error.context.json();
    if (typeof body?.error === 'string') message = body.error;
  } catch {
    // Network failure or unparseable body: keep the generic message.
  }
  throw new SubmitError(message);
}
